export const Locales = {
  ENGLISH: "en-UK",
  UKRAINIAN: "uk-EN",
};
